import 'tailwindcss/dist/base.min.css'
import { checkHash, isBrowser, scroller } from './src/utils/scroll'

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    require(`intersection-observer`) // eslint-disable-line global-require
  }
}

export { wrapPageElement } from './gatsby-ssr'

export const onRouteUpdate = ({ location }) => {
  let windowHash

  if (isBrowser) {
    windowHash = window.gatsby_scroll_hash
  }

  if (windowHash) {
    scroller(windowHash)
  } else {
    checkHash(location)
  }

  if (isBrowser && windowHash) {
    window.gatsby_scroll_hash = undefined
  }
}
